export default __webpack_public_path__ + "static/media/Inkedjessica-biel-justin-timberlake_LI.ca940046.jpg";